import { FC } from "react"
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from "../../../redux/store";
import QuestionUpdateHeader from "./QuestionUpdateHeader";
import { useDispatch } from 'react-redux';
import EditHeight from "../../../components/EditHeight";
import NiceModal from "@ebay/nice-modal-react";
import { updateMemberHeight } from "../../../services/memberService";
import { setUserData } from "../../../redux/member";
const UpdateHeight: FC = () => {

    const member = useSelector((state: RootState) => state.member);
    let history = useHistory();
    const dispatch = useDispatch();


    const onSave = async (selectedHeight: number) => {
        try {
            let res = await updateMemberHeight(selectedHeight);
            if (res.status === 200) {
                dispatch(setUserData({ ...member, height: selectedHeight }))
                history.goBack();
            }
        } catch (e) {
            NiceModal.show("action_modal", {
                onNext: () => { NiceModal.hide("action_modal"); },
                headerTitle: "שגיאה לא צפויה",
                contentTitle: <div>קרתה שגיאה בתהליך עדכון הנתונים</div>,
                primaryButtonText: "הבנתי",
                showCloseButton: false,
                showSeconderyButton: false
            });
        }
    };


    return (
        <>
            <QuestionUpdateHeader />
            <EditHeight
                buttonText={"שמור"}
                subtitle={""}
                title={"מה הגובה שלך?"}
                onSave={onSave}

            />
        </>
    )
}

export default UpdateHeight
